
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"17","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.691 14.287a.33.33 0 00.027-.134.305.305 0 00-.053-.126.6.6 0 00-.16-.147l-3.473-2.187-.032-.01a.256.256 0 00-.07-.029 1.03 1.03 0 00-.177-.023.712.712 0 00-.246.024.712.712 0 00-.215.107l-1.117.93h-.001a.765.765 0 01-.332.156c-.052.012-.09.02-.12.025a.73.73 0 01-.163.01l-.098-.015-.23-.057a2.24 2.24 0 01-.367-.133 5.634 5.634 0 01-.418-.209v-.001c-.826-.454-1.776-1.25-2.606-2.126-.836-.882-1.562-1.857-1.929-2.654a4.368 4.368 0 01-.206-.508 2.836 2.836 0 01-.113-.477l-.005-.087a.77.77 0 01.075-.272 1 1 0 01.074-.138.653.653 0 01.132-.147v-.002l.976-.8.002.002a.618.618 0 00.203-.312.398.398 0 00.019-.156.328.328 0 00-.04-.132l-.005-.012-1.76-3.636a.757.757 0 00-.17-.19.178.178 0 00-.056-.03.253.253 0 00-.074-.016v.003a.313.313 0 00-.12.013.444.444 0 00-.132.079L1.06 3.038l-.02.016a.703.703 0 00-.11.1 1.29 1.29 0 00-.253.483l-.011.082-.031.247-.005.037-.003.04h.001v.015H.625a3.913 3.913 0 00.029.675c.238 2.337 2.16 5.485 4.715 8.001 2.286 2.25 5.06 3.975 7.558 4.12.071.005.111.006.118.006.028.002.052 0 .076 0 .085-.003.054-.003.083-.004h.035a1.49 1.49 0 00.37-.09c.063-.024.122-.051.175-.083a.773.773 0 00.122-.088l.02-.017 2.649-2.15a.417.417 0 00.116-.14","fill":"#FFF","fill-rule":"evenodd"}})])
          )
        }
      }
    